/* eslint-disable */
// @ts-nocheck

let randomFactor = 25 + Math.random() * 25
const samplePoint = (i) =>
  i *
    (0.5 +
      Math.sin(i / 1) * 0.2 +
      Math.sin(i / 2) * 0.4 +
      Math.sin(i / randomFactor) * 0.8 +
      Math.sin(i / 50) * 0.5) +
  200 +
  i * 2

function generateData(numberOfCandles = 500, updatesPerCandle = 5, startAt = 100) {
  const createCandle = (val, time) => ({
    time,
    open: val,
    high: val,
    low: val,
    close: val
  })

  const updateCandle = (candle, val) => ({
    time: candle.time,
    close: val,
    open: candle.open,
    low: Math.min(candle.low, val),
    high: Math.max(candle.high, val)
  })

  randomFactor = 25 + Math.random() * 25
  const date = new Date(Date.UTC(2018, 0, 1, 12, 0, 0, 0))
  const numberOfPoints = numberOfCandles * updatesPerCandle
  const initialData = []
  const realtimeUpdates = []
  let lastCandle
  let previousValue = samplePoint(-1)
  for (let i = 0; i < numberOfPoints; ++i) {
    if (i % updatesPerCandle === 0) {
      date.setUTCDate(date.getUTCDate() + 1)
    }
    const time = date.getTime() / 1000
    let value = samplePoint(i)
    const diff = (value - previousValue) * Math.random()
    value = previousValue + diff
    previousValue = value
    if (i % updatesPerCandle === 0) {
      const candle = createCandle(value, time)
      lastCandle = candle
      if (i >= startAt) {
        realtimeUpdates.push(candle)
      }
    } else {
      const newCandle = updateCandle(lastCandle, value)
      lastCandle = newCandle
      if (i >= startAt) {
        realtimeUpdates.push(newCandle)
      } else if ((i + 1) % updatesPerCandle === 0) {
        initialData.push(newCandle)
      }
    }
  }

  return {
    initialData,
    realtimeUpdates
  }
}
function* getNextRealtimeUpdate(realtimeData: Array<unknown>) {
  for (const dataPoint of realtimeData) {
    yield dataPoint
  }
  return null
}

const data = generateData(2500, 20, 1000)

function toPointModel(
  candle: { time: number; open: number; high: number; low: number; close: number },
  symbol: string
) {
  return {
    time: candle.time,
    open: candle.open,
    high: candle.high,
    low: candle.low,
    close: candle.close,
    volume: 0,
    value: candle.close,
    symbol
  }
}

export class TraidingDataMockApi {
  public async getInitial(dto: { symbol: string; limit: number }): Promise<ReturnType<typeof toPointModel>[]> {
    await new Promise((resolve) => setTimeout(resolve, 100))
    return data.initialData.slice(-dto.limit).map((candle) => toPointModel(candle, dto.symbol))
  }

  public async getPrevious(dto: {
    symbol: string
    limit: number
    endTime: number
  }): Promise<ReturnType<typeof toPointModel>[]> {
    await new Promise((resolve) => setTimeout(resolve, 100))
    return data.initialData
      .filter((candle) => candle.time < dto.endTime)
      .slice(-dto.limit)
      .map((candle) => toPointModel(candle, dto.symbol))
  }

  public async getNext(dto: { symbol: string }): Promise<ReturnType<typeof toPointModel>> {
    const candle = data.realtimeUpdates[0] ?? data.initialData[data.initialData.length - 1]
    return toPointModel(candle, dto.symbol)
  }

  getAll(): Promise<CallableFunction> {
    return new Promise((res) => {
      setTimeout(() => {
        const streamingDataProvider = getNextRealtimeUpdate(data.realtimeUpdates)
        res((cb: CallableFunction) => {
          const intervalID = setInterval(() => {
            const update = streamingDataProvider.next()
            if (update.done) {
              clearInterval(intervalID)
              return
            }
            cb(update.value)
          }, 100)
        })
      }, 2000)
    })
  }
}
